import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { supabase } from '../supabase';
import { t } from '../data/translations';
import { PLAN_LIMITS, CAT_META } from '../data/initialState';
import Confetti from './Confetti';

const getCurrency = (lang) => lang==='en'?'$':lang==='da'?'kr (DKK)':lang==='sv'?'kr (SEK)':'kr';
const fmt = (n, lang) => {
  const num = Math.round(Math.abs(n || 0)).toLocaleString(lang==='en'?'en-US':lang==='sv'?'sv-SE':lang==='da'?'da-DK':'nb-NO');
  return lang==='en' ? '$' + num : num + ' ' + (lang==='da'?'DKK':lang==='sv'?'SEK':'kr');
};

const EMOJIS = ['🏠','✈️','🚗','📱','💻','🎓','💍','🌴','🎮','👟','🎸','🐕','🏋️','🛋️','💰'];
const COLORS = ['#22C97A','#378ADD','#F5C518','#FF6B9D','#7C3AED','#FF8C42','#06B6D4'];

function GoalForm({ goal, onSave, onCancel, lang='en' }) {
  const [name, setName] = useState(goal?.name || '');
  const [target, setTarget] = useState(goal?.target || '');
  const [saved, setSaved] = useState(goal?.saved || 0);
  const [emoji, setEmoji] = useState(goal?.emoji || '💰');
  const [colorIdx, setColorIdx] = useState(COLORS.indexOf(goal?.color) >= 0 ? COLORS.indexOf(goal?.color) : 0);
  const [deadline, setDeadline] = useState(goal?.deadline || '');

  const save = () => {
    if (!name.trim() || !target) return;
    onSave({ id: goal?.id || Date.now(), name: name.trim(), target: parseFloat(target), saved: parseFloat(saved)||0, emoji, color: COLORS[colorIdx], deadline });
  };

  return (
    <div style={{ background:'var(--card)', border:'1.5px solid var(--border)', borderRadius:'var(--r-xl)', padding:'1.25rem', marginBottom:'1rem' }}>
      <div style={{ fontFamily:'var(--font-display)', fontSize:15, fontWeight:700, color:'var(--ink)', marginBottom:12 }}>
        {goal ? (lang==='en'?'Edit goal':lang==='sv'?'Redigera mål':lang==='da'?'Rediger mål':'Rediger mål') : (lang==='en'?'New goal':lang==='sv'?'Nytt mål':lang==='da'?'Nyt mål':'Nytt mål')}
      </div>
      <div style={{ marginBottom:10 }}>
        <label style={{ fontSize:12, color:'var(--ink3)', display:'block', marginBottom:4 }}>Emoji</label>
        <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
          {EMOJIS.map(e => <button key={e} onClick={() => setEmoji(e)} style={{ fontSize:20, background: emoji===e ? 'var(--g50)' : 'var(--surface)', border: emoji===e ? '2px solid var(--g400)' : '1px solid var(--border)', borderRadius:'var(--r-md)', width:40, height:40, cursor:'pointer' }}>{e}</button>)}
        </div>
      </div>
      <div style={{ marginBottom:10 }}>
        <label style={{ fontSize:12, color:'var(--ink3)', display:'block', marginBottom:4 }}>{lang==='en'?'Color':lang==='sv'?'Färg':lang==='da'?'Farve':'Farge'}</label>
        <div style={{ display:'flex', gap:8 }}>
          {COLORS.map((c,i) => (
            <button key={c} onClick={() => setColorIdx(i)} style={{ width: colorIdx===i?40:34, height: colorIdx===i?40:34, borderRadius:'50%', background:c, border: colorIdx===i?'3px solid var(--ink)':'2px solid transparent', cursor:'pointer', transition:'all 0.2s', flexShrink:0 }}/>
          ))}
        </div>
      </div>
      <div style={{ marginBottom:10 }}>
        <label style={{ fontSize:12, color:'var(--ink3)', display:'block', marginBottom:4 }}>{lang==='en'?'Goal name':lang==='sv'?'Målnamn':lang==='da'?'Målnavn':'Målnavn'}</label>
        <input value={name} onChange={e=>setName(e.target.value)} placeholder={lang==='en'?'e.g. iPhone 16':'f.eks. iPhone 16'} style={{ width:'100%', fontSize:14 }}/>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:10 }}>
        <div>
          <label style={{ fontSize:12, color:'var(--ink3)', display:'block', marginBottom:4 }}>{lang==='en'?'Target amount':lang==='sv'?'Målbelopp':lang==='da'?'Målbeløb':'Målbeløp'}</label>
          <input type="number" value={target} onChange={e=>setTarget(e.target.value)} placeholder="5000" style={{ width:'100%', fontSize:14 }}/>
        </div>
        <div>
          <label style={{ fontSize:12, color:'var(--ink3)', display:'block', marginBottom:4 }}>{lang==='en'?'Already saved':lang==='sv'?'Redan sparat':lang==='da'?'Allerede sparet':'Allerede spart'}</label>
          <input type="number" value={saved} onChange={e=>setSaved(e.target.value)} placeholder="0" style={{ width:'100%', fontSize:14 }}/>
        </div>
      </div>
      <div style={{ marginBottom:'1rem' }}>
        <label style={{ fontSize:12, color:'var(--ink3)', display:'block', marginBottom:4 }}>{lang==='en'?'Deadline (optional)':lang==='sv'?'Deadline (valfri)':lang==='da'?'Deadline (valgfri)':'Frist (valgfritt)'}</label>
        <input type="month" value={deadline} onChange={e=>setDeadline(e.target.value)} style={{ width:'100%', fontSize:14 }}/>
      </div>
      <div style={{ display:'flex', gap:8 }}>
        <button onClick={save} style={{ flex:1, padding:13, background:'var(--g400)', color:'var(--ink)', border:'none', borderRadius:'var(--r-lg)', fontFamily:'var(--font-display)', fontSize:14, fontWeight:700, cursor:'pointer' }}>
          {goal ? (lang==='en'?'Save ✓':lang==='sv'?'Spara ✓':lang==='da'?'Gem ✓':'Lagre ✓') : (lang==='en'?'Create goal 🎯':lang==='sv'?'Skapa mål 🎯':lang==='da'?'Opret mål 🎯':'Opprett mål 🎯')}
        </button>
        <button onClick={onCancel} style={{ padding:'13px 16px', background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--r-lg)', fontSize:14, cursor:'pointer', color:'var(--ink3)' }}>✕</button>
      </div>
    </div>
  );
}

export default function TabMaal({ syncGoal }) {
  const { state, dispatch } = useApp();
  const lang = state.language || 'en';
  const [showAdd, setShowAdd] = useState(false);
  const [editGoal, setEditGoal] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);
  const [saveGoalId, setSaveGoalId] = useState(null);
  const [saveAmount, setSaveAmount] = useState('');
  const [saveDone, setSaveDone] = useState(null);
  const [showAllGoals, setShowAllGoals] = useState(false);

  const limits = PLAN_LIMITS[state.plan] || PLAN_LIMITS.free;
  const isPro = state.plan === 'advanced' || state.plan === 'premium';
  const isPremium = state.plan === 'premium';
  const isFree = !isPro;
  const atLimit = (state.goals || []).length >= limits.maxGoals;

  const addGoal = (g) => {
    dispatch({ type:'ADD_GOAL', payload: g });
    dispatch({ type:'ADD_XP', payload:50 });
    if (syncGoal) syncGoal(g, 'add');
    setShowAdd(false);
  };

  const saveEdit = (g) => {
    dispatch({ type:'EDIT_GOAL', payload: g });
    if (syncGoal) syncGoal(g, 'update');
    setEditGoal(null);
  };

  const handleSaveToGoal = (goal) => {
    const amt = Math.abs(parseFloat(saveAmount) || 0);
    if (!amt || amt <= 0) return;
    const willComplete = (goal.saved + amt) >= goal.target;
    const updated = { ...goal, saved: Math.min(goal.target, goal.saved + amt) };
    const updatedGoal = { ...goal, saved: Math.min(goal.target, goal.saved + amt) };
    dispatch({ type:'UPDATE_GOAL', payload: updatedGoal });
    dispatch({ type:'SAVE_TO_GOAL', payload:{ goalId: goal.id, amount: amt } });
    dispatch({ type:'ADD_XP', payload:50 });
    const tx = { id:Date.now(), desc:`${lang==='en'?'Saved for':lang==='sv'?'Sparat till':lang==='da'?'Sparet til':'Spart til'} ${goal.name}`, cat:'Sparing', amount:amt, date:'I dag', time:new Date().toTimeString().slice(0,5) };
    dispatch({ type:'ADD_TRANSACTION', payload:tx });
    if (syncGoal) syncGoal(updated, 'update');
    setSaveAmount('');
    setSaveGoalId(null);
    setSaveDone(goal.id);
    if (willComplete || amt >= 100) { setShowConfetti(true); setTimeout(() => setShowConfetti(false), 3000); }
    setTimeout(() => setSaveDone(null), 2500);
  };

  const challenges = [
    { id:'c1', emoji:'💰', name: lang==='en'?'Save 100':lang==='sv'?'Spara 100':lang==='da'?'Spar 100':'Spar 100', desc: lang==='en'?'Save kr 100 today':lang==='sv'?'Spara 100 kr idag':lang==='da'?'Spar 100 kr i dag':'Spar 100 kr i dag', xp:50 },
    { id:'c2', emoji:'🎯', name: lang==='en'?'Stay on budget':lang==='sv'?'Håll budgeten':lang==='da'?'Hold budgettet':'Hold budsjettet', desc: lang==='en'?'Spend less than your daily budget':lang==='sv'?'Spendera mindre än din dagliga budget':lang==='da'?'Brug mindre end dit daglige budget':'Bruk mindre enn daglig budsjett', xp:75 },
    { id:'c3', emoji:'🚫', name: lang==='en'?'No impulse':lang==='sv'?'Inget impulsköp':lang==='da'?'Ingen impuls':'Ingen impuls', desc: lang==='en'?'Avoid impulse purchases today':lang==='sv'?'Undvik impulsköp idag':lang==='da'?'Undgå impulskøb i dag':'Unngå impulskjøp i dag', xp:60 },
    { id:'c4', emoji:'📝', name: lang==='en'?'Log expenses':lang==='sv'?'Logga utgifter':lang==='da'?'Log udgifter':'Logg utgifter', desc: lang==='en'?'Add 3 transactions today':lang==='sv'?'Lägg till 3 transaktioner idag':lang==='da'?'Tilføj 3 transaktioner i dag':'Legg til 3 transaksjoner i dag', xp:40 },
  ];
  const [completedChallenges, setCompletedChallenges] = useState(state.completedChallenges || []);
  const completeChallenge = (ch) => {
    if (completedChallenges.includes(ch.id)) return;
    dispatch({ type:'ADD_XP', payload: ch.xp });
    setCompletedChallenges(p => [...p, ch.id]);
  };

  return (
    <>
      <Confetti active={showConfetti}/>
      <div style={{ padding:'1.25rem 1rem' }}>

        <div className="fade-up" style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1rem' }}>
          <div>
            <div style={{ fontFamily:'var(--font-display)', fontSize:22, fontWeight:800, color:'var(--ink)' }}>
              {lang==='en'?'Savings Goals':lang==='sv'?'Sparmål':lang==='da'?'Sparemål':'Sparemål'}
            </div>
            {isFree && <div style={{ fontSize:12, color:'var(--ink3)' }}>{(state.goals||[]).length}/{limits.maxGoals} {lang==='en'?'goals used':lang==='sv'?'mål använda':lang==='da'?'mål brugt':'mål brukt'}</div>}
          </div>
          {!atLimit && !showAdd && !editGoal && (
            <button onClick={() => setShowAdd(true)} style={{ padding:'8px 16px', background:'var(--g400)', color:'var(--ink)', border:'none', borderRadius:'var(--r-full)', fontFamily:'var(--font-display)', fontSize:13, fontWeight:700, cursor:'pointer' }}>
              + {lang==='en'?'New goal':lang==='sv'?'Nytt mål':lang==='da'?'Nyt mål':'Nytt mål'}
            </button>
          )}
        </div>

        {showAdd && !atLimit && <GoalForm lang={lang} onSave={addGoal} onCancel={() => setShowAdd(false)}/>}
        {editGoal && <GoalForm lang={lang} goal={editGoal} onSave={saveEdit} onCancel={() => setEditGoal(null)}/>}

        {atLimit && !isPro && (
          <div style={{ background:'var(--surface)', border:'1.5px dashed var(--border)', borderRadius:'var(--r-lg)', padding:'1rem', textAlign:'center', marginBottom:'1rem' }}>
            <div style={{ fontSize:13, color:'var(--ink3)', marginBottom:8 }}>
              {lang==='en'?`You've reached the ${limits.maxGoals} goal limit`:lang==='sv'?`Du har nått gränsen på ${limits.maxGoals} mål`:lang==='da'?`Du har nået grænsen på ${limits.maxGoals} mål`:`Du har nådd grensen på ${limits.maxGoals} mål`}
            </div>
            <button onClick={() => alert(lang==='en'?'Upgrade to Premium to unlock weekly challenges! Contact us at support@mysavely.app':lang==='sv'?'Uppgradera till Premium för att låsa upp veckoutmaningar!':lang==='da'?'Opgrader til Premium for at låse ugentlige udfordringer op!':'Oppgrader til Premium for å låse opp ukentlige utfordringer!')} style={{ padding:'8px 18px', background:'var(--g400)', color:'var(--ink)', border:'none', borderRadius:'var(--r-full)', fontSize:12, fontWeight:700, cursor:'pointer' }}>
              {lang==='en'?'Upgrade for unlimited':lang==='sv'?'Uppgradera för obegränsat':lang==='da'?'Opgrader for ubegrænset':'Oppgrader for ubegrenset'} →
            </button>
          </div>
        )}

        <div style={{ display:'flex', flexDirection:'column', gap:12, marginBottom:'1.5rem' }}>
          {(showAllGoals ? (state.goals || []) : (state.goals || []).slice(0,3)).map((goal, idx) => {
            const pct = Math.min(100, (goal.target > 0 ? Math.round(goal.saved / goal.target * 100) : 0));
            const done = pct >= 100;
            const remaining = goal.target - goal.saved;
            const monthsLeft = goal.deadline ? Math.max(1, Math.round((new Date(goal.deadline) - new Date()) / (1000*60*60*24*30))) : null;
            const monthlyNeeded = monthsLeft ? Math.ceil(remaining / monthsLeft) : null;
            return (
              <div key={goal.id} className={idx < 3 ? `fade-up-${idx+1}` : ''} style={{ background: done ? 'var(--g50)' : 'var(--card)', border:`1.5px solid ${done ? 'var(--g200)' : 'var(--border)'}`, borderRadius:'var(--r-xl)', padding:'1.25rem', position:'relative', overflow:'hidden' }}>
                {done && <div style={{ position:'absolute', top:12, right:12, background:'var(--g400)', color:'var(--ink)', fontSize:10, fontWeight:700, borderRadius:999, padding:'2px 8px' }}>✅ {lang==='en'?'Done!':lang==='sv'?'Klar!':lang==='da'?'Færdig!':'Fullført!'}</div>}
                <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:12 }}>
                  <div style={{ width:48, height:48, borderRadius:'var(--r-md)', background:goal.color+'22', border:`2px solid ${goal.color}44`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:24, flexShrink:0 }}>{goal.emoji}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontFamily:'var(--font-display)', fontSize:16, fontWeight:700, color:'var(--ink)' }}>{goal.name}</div>
                    <div style={{ fontSize:12, color:'var(--ink3)' }}>{fmt(goal.saved, lang)} {lang==='en'?'of':lang==='sv'?'av':lang==='da'?'af':'av'} {fmt(goal.target, lang)}{monthlyNeeded && !done ? ` · ${fmt(monthlyNeeded, lang)}/${lang==='en'?'mo':lang==='sv'?'mån':lang==='da'?'mdr':'mnd'}` : ''}</div>
                  </div>
                  <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                    {!done && <button onClick={() => { setEditGoal(goal); setShowAdd(false); }} style={{ fontSize:16, background:'none', border:'none', cursor:'pointer' }}>✏️</button>}
                    <button onClick={() => { const savedAmt = goal.saved; dispatch({ type:'DELETE_GOAL', payload:goal.id }); }} style={{ fontSize:16, background:'none', border:'none', cursor:'pointer' }}>🗑️</button>
                  </div>
                </div>
                <div style={{ background:'var(--surface)', borderRadius:999, height:10, marginBottom:8, overflow:'hidden' }}>
                  <div style={{ width:pct+'%', height:'100%', background:goal.color, borderRadius:999, transition:'width 0.5s ease' }}/>
                </div>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: done ? 0 : 10 }}>
                  <div style={{ fontSize:12, color:'var(--ink3)' }}>{goal.deadline ? `${lang==='en'?'Deadline':'Frist'}: ${goal.deadline}` : lang==='en'?'No deadline':lang==='sv'?'Ingen deadline':lang==='da'?'Ingen frist':'Ingen frist'}</div>
                  <div style={{ fontFamily:'var(--font-display)', fontSize:18, fontWeight:800, color:goal.color }}>{pct}%</div>
                </div>
                {goal.target === 0 && (
                <div style={{ padding:'8px 12px', background:'rgba(245,197,24,0.1)', border:'1px solid rgba(245,197,24,0.3)', borderRadius:'var(--r-md)', fontSize:12, color:'#B45309', fontWeight:600, textAlign:'center' }}>
                  {lang==='en'?'⚡ Set up your goal first →':lang==='sv'?'⚡ Ställ in ditt mål först →':lang==='da'?'⚡ Opsæt dit mål først →':'⚡ Fullfør mål-oppsett først →'}
                </div>
              )}
              {goal.target > 0 && !done && (
                  <div>
                    {saveGoalId === goal.id ? (
                      <div className="fade-up" style={{ display:'flex', gap:8, alignItems:'center' }}>
                        <input type="number" value={saveAmount} onChange={e=>setSaveAmount(e.target.value)}
                          placeholder={lang==='en'?'Amount...':lang==='sv'?'Belopp...':lang==='da'?'Beløb...':'Beløp...'}
                          onKeyDown={e=>e.key==='Enter'&&handleSaveToGoal(goal)}
                          style={{ flex:1, fontSize:15, fontWeight:600 }} autoFocus/>
                        <button onClick={() => handleSaveToGoal(goal)} style={{ padding:'8px 14px', background:goal.color, color:'#fff', border:'none', borderRadius:'var(--r-full)', fontWeight:700, fontSize:13, cursor:'pointer' }}>
                          {lang==='en'?'Save':lang==='sv'?'Spara':lang==='da'?'Gem':'Lagre'} 💰
                        </button>
                        <button onClick={() => { setSaveGoalId(null); setSaveAmount(''); }} style={{ padding:'8px 12px', background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--r-full)', fontSize:12, cursor:'pointer' }}>✕</button>
                      </div>
                    ) : saveDone === goal.id ? (
                      <div className="fade-up" style={{ textAlign:'center', padding:'8px', background:'var(--g50)', borderRadius:'var(--r-md)' }}>
                        <div style={{ fontSize:24 }}>🎉</div>
                        <div style={{ fontSize:13, fontWeight:700, color:'var(--g600)' }}>{lang==='en'?'Saved!':lang==='sv'?'Sparat!':lang==='da'?'Gemt!':'Spart!'}</div>
                      </div>
                    ) : (
                      <button onClick={() => { setSaveGoalId(goal.id); setSaveAmount(''); }} style={{ width:'100%', padding:'10px', borderRadius:'var(--r-lg)', background:`${goal.color}15`, border:`1.5px solid ${goal.color}44`, color:goal.color, fontFamily:'var(--font-display)', fontSize:13, fontWeight:700, cursor:'pointer' }}>
                        💰 {lang==='en'?'Save to this goal':lang==='sv'?'Spara till detta mål':lang==='da'?'Spar til dette mål':'Spar til dette målet'}
                      </button>
                    )}
                  </div>
                )}
              </div>
            );
          })}
          {(state.goals || []).length === 0 && (
            <div style={{ textAlign:'center', padding:'2rem 1rem', color:'var(--ink3)' }}>
              <div style={{ fontSize:40, marginBottom:12 }}>🎯</div>
              <div style={{ fontFamily:'var(--font-display)', fontSize:16, fontWeight:700, marginBottom:8 }}>{lang==='en'?'No goals yet':lang==='sv'?'Inga mål ännu':lang==='da'?'Ingen mål endnu':'Ingen mål ennå'}</div>
              <div style={{ fontSize:14 }}>{lang==='en'?'Create your first savings goal!':lang==='sv'?'Skapa ditt första sparmål!':lang==='da'?'Opret dit første sparemål!':'Opprett ditt første sparemål!'}</div>
            </div>
          )}

        {!showAllGoals && (state.goals || []).length > 3 && (
          <button onClick={() => setShowAllGoals(true)} style={{ width:'100%', padding:'10px', borderRadius:'var(--r-md)', border:'1px dashed var(--border)', background:'var(--surface)', color:'var(--ink3)', fontSize:13, cursor:'pointer', marginTop:4 }}>
            {lang==='en'?`See all ${(state.goals||[]).length} goals`:lang==='sv'?`Se alla ${(state.goals||[]).length} mål`:lang==='da'?`Se alle ${(state.goals||[]).length} mål`:`Se alle ${(state.goals||[]).length} mål`} ↓
          </button>
        )}
        {showAllGoals && (state.goals || []).length > 3 && (
          <button onClick={() => setShowAllGoals(false)} style={{ width:'100%', padding:'8px', borderRadius:'var(--r-md)', border:'none', background:'none', color:'var(--ink4)', fontSize:12, cursor:'pointer' }}>
            {lang==='en'?'Show less':lang==='sv'?'Visa mindre':lang==='da'?'Vis mindre':'Vis mindre'} ↑
          </button>
        )}
        </div>

        {!isFree && challenges.length > 0 && (
          <>
            <div style={{ fontFamily:'var(--font-display)', fontSize:15, fontWeight:700, color:'var(--ink)', marginBottom:'0.75rem' }}>
              {isPremium ? '⚡ ' + (lang==='en'?'Daily challenges':lang==='sv'?'Dagliga utmaningar':lang==='da'?'Daglige udfordringer':'Daglige utfordringer') : '🏆 ' + (lang==='en'?'Weekly challenges':lang==='sv'?'Veckoutmaningar':lang==='da'?'Ugentlige udfordringer':'Ukentlige utfordringer')}
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
              {(challenges || []).map(ch => {
                const done = completedChallenges.includes(ch.id);
                return (
                  <div key={ch.id} style={{ background: done ? 'var(--g50)' : 'var(--card)', border:`1.5px solid ${done ? 'var(--g200)' : 'var(--border)'}`, borderRadius:'var(--r-lg)', padding:'0.875rem', display:'flex', alignItems:'center', gap:12 }}>
                    <div style={{ fontSize:28, flexShrink:0 }}>{ch.emoji}</div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:14, fontWeight:600, color: done ? 'var(--g600)' : 'var(--ink)' }}>{ch.title}</div>
                      <div style={{ fontSize:12, color:'var(--ink3)' }}>{ch.desc}</div>
                      <div style={{ fontSize:11, color:'var(--g600)', marginTop:3, fontWeight:700 }}>+{ch.xp} XP</div>
                    </div>
                    <button onClick={() => completeChallenge(ch)} style={{ padding:'8px 14px', fontSize:12, fontWeight:700, border:'none', borderRadius:'var(--r-full)', cursor: done ? 'default':'pointer', background: done ? 'var(--g200)':'var(--g400)', color:'var(--ink)' }}>
                      {done ? '✅' : (lang==='en'?'Done!':lang==='sv'?'Klar!':lang==='da'?'Færdig!':'Fullført!')}
                    </button>
                  </div>
                );
              })}
            </div>
          </>
        )}


        {isFree && (
        <div style={{ background:'linear-gradient(135deg,rgba(99,102,241,0.1),rgba(124,58,237,0.1))', border:'1.5px solid rgba(99,102,241,0.3)', borderRadius:'var(--r-lg)', padding:'1.25rem', marginTop:'1rem', textAlign:'center' }}>
          <div style={{ fontSize:32, marginBottom:8 }}>🏆</div>
          <div style={{ fontFamily:'var(--font-display)', fontSize:16, fontWeight:700, color:'var(--ink)', marginBottom:6 }}>
            {lang==='en'?'Weekly Challenges':lang==='sv'?'Veckliga utmaningar':lang==='da'?'Ugentlige udfordringer':'Ukentlige utfordringer'}
          </div>
          <div style={{ fontSize:13, color:'var(--ink3)', marginBottom:14 }}>
            {lang==='en'?'Complete challenges to earn XP and rewards!':lang==='sv'?'Slutför utmaningar för att tjäna XP och belöningar!':lang==='da'?'Gennemfør udfordringer for at tjene XP og belønninger!':'Fullfør utfordringer for å tjene XP og belønninger!'}
          </div>
          <button onClick={() => alert(lang==='en'?'Upgrade to Premium to unlock weekly challenges! Contact us at support@mysavely.app':lang==='sv'?'Uppgradera till Premium för att låsa upp veckoutmaningar!':lang==='da'?'Opgrader til Premium for at låse ugentlige udfordringer op!':'Oppgrader til Premium for å låse opp ukentlige utfordringer!')} style={{ padding:'10px 24px', background:'linear-gradient(135deg,#4F46E5,#7C3AED)', color:'#fff', border:'none', borderRadius:'var(--r-full)', fontWeight:700, fontSize:13, cursor:'pointer' }}>
            {lang==='en'?'👑 Upgrade to Premium →':lang==='sv'?'👑 Uppgradera till Premium →':lang==='da'?'Opgrader til Premium →':'Oppgrader til Premium →'}
          </button>
        </div>
      )}

      <div style={{ height:16 }}/>
      </div>
    </>
  );
}
